import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";

import DropboxPlayer from "../DropboxPlayer";
import "./Styles/Styles.scss";
import { TikTokThumbnail, YoutubeThumbnail } from "./ThumbnailByPlatform";
import {
  updateParams,
  updateVideoPageState,
} from "../../Pages/Video/VideoActions";
import { addDefaultSrc } from "../../utilities";
const defaultIcon = require("@src/assets/images/vyrill/default.png").default;
import { updateTutorialState } from "../Tutorials/TutorialActions";
import { fetchNavbarStats } from "../../vyrill-ui-config/layout/sidebar/navbarStatsActions";

const Step3SuccessMessage = ({
  open,
  handleClose,
  successData,
  addCompetitorVideo,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isCategoryPage = useSelector(
    (state) => state.videoPageStates.isCategoryPage
  );
  const videoData = useSelector((state) => state.videoData.count);
  const videoIndexPage = () => {
    if (!location?.pathname?.includes("videos")) {
      dispatch(fetchNavbarStats());
      navigate("/videos");
      // TODO:
      if (localStorage.getItem("toturialScreen") === "firstVideo") {
        dispatch(
          updateTutorialState({
            isTutorial: true,
            activeTutorial: "first-video",
            activeStep: 1,
            totalSteps: 2,
          })
        );
      }
    }
    if (isCategoryPage) {
      dispatch(updateVideoPageState({ isCategoryPage: false }));
    }
    if (!(location?.pathname?.includes("videos") && !isCategoryPage)) {
      dispatch(updateParams({ reFetch: true }));
    }
    dispatch(updateParams({ reFetch: true }));
    handleClose(!open, "step3Modal");
  };
  const dropboxThumbnail = (
    <div className="videoWrapper">
      <DropboxPlayer
        styleClass={"videoFrame"}
        videoUrl={successData.video_url}
      />
    </div>
  );

  const tiktokThumbnail = (
    <TikTokThumbnail
      selectedImage={successData.thumbnail_url}
      customStyles={{
        background: "black",
        height: "363px",
        overflow: "hidden",
      }}
      imgStyles={{ height: "inherit" }}
    />
  );

  const instagramThumbnail = (
    <img
      height={363}
      src={successData?.thumbnail_url}
      onError={(event) => addDefaultSrc(event, defaultIcon)}
    />
  );

  return (
    <Modal
      size="lg"
      isOpen={open}
      toggle={() => {
        handleClose(!open, "step3Modal");
        dispatch(fetchNavbarStats());
      }}
      className="Step3SuccessMessage Step2FetchDetails VideoProcess modal-dialog-centered"
    >
      {/* <ModalHeader className="justify-content-end">
        <X
          size={30}
          role="button"
          onClick={() => {
            handleClose(!open, "step3Modal");
            dispatch(fetchNavbarStats());
          }}
        />
      </ModalHeader> */}
      <ModalBody className="p-0" style={{ height: "601px" }}>
        <>
          <div
            className="d-flex justify-content-center"
            style={{ background: "black", height: "363px" }}
          >
            <div className="MainImageContainer" style={{ textAlign: "center" }}>
              {successData.platform === "localVideo" && (
                <video
                  width="100%"
                  height="363px"
                  src={successData.video_url}
                />
              )}
              {successData.platform === "Dropbox" && (
                <video
                  width="100%"
                  height="363px"
                  src={successData.video_url}
                />
              )}
              {successData.platform === "Youtube" && (
                <YoutubeThumbnail selectedImage={successData.thumbnail_url} />
              )}
              {successData.platform === "GoogleDrive" && (
                <img
                  src={successData?.thumbnail_url || ""}
                  width="100%"
                  height={363}
                />
              )}
              {successData.platform === "Tiktok" && tiktokThumbnail}
              {successData.platform === "Instagram" && instagramThumbnail}
            </div>
          </div>

          <div className="d-flex justify-content-center mt-4 mb-1">
            <h2
              style={{ color: "black", width: "max-content", fontSize: "20px" }}
            >
              {videoData >= 1
                ? "Congratulations! Your video has been successfully uploaded!"
                : "Your first video has been successfully uploaded!"}
            </h2>
          </div>

          <div>
            <h4
              style={{ color: "#4B4949", fontSize: "16px" }}
              className="modal-text mb-3"
            >
              Your new video is now in the <b>Videos</b> tab under{" "}
              <strong>
                {addCompetitorVideo ? "My Competitors." : "My Videos."}
              </strong>{" "}
              <br />
              <span
                style={{
                  color: "#783AD0",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
                onClick={videoIndexPage}
              >
                Click here
              </span>{" "}
              to view it in the dashboard
            </h4>
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default Step3SuccessMessage;
